import React, { useState, useEffect } from 'react';
import { Box, Container, CssBaseline, Stack, Grid, Typography, Button } from '@mui/material';
import { Link, useNavigate } from 'react-router-dom';
import PageHeading from '../../global/header/PageHeading';
import onBoardingEkycServices from '../../../services/onBoarding-ekyc-services';
import Loader from '../../global/Loader';
import DialogMsg from '../../global/DialogMsg';
import { useTranslation } from 'react-i18next';

const { GetDocList } = onBoardingEkycServices;

const DocumentChoose = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const [openloader, setOpenloader] = useState(false);
  const [openDialogeMsg, setOpenDialogeMsg] = useState(false);
  const [dialogMsg, setDialogMsg] = useState('');
  const [docList, setDocList] = useState([]);
  console.log('docList', docList);

  const urlParams = new URLSearchParams(window.location.search);
  const ocrType = urlParams.get('ocrType');

  // GetDocListApi
  const GetDocListApi = async () => {
    try {
      setOpenloader(true);
      let credential = { isOrcDocsList: ocrType === 'false' ? false : true };
      const GetDocListResponse = await GetDocList(credential);
      if (GetDocListResponse.status === 'Success') {
        if (GetDocListResponse.data.length > 0) {
          const arrayFilter = GetDocListResponse.data.filter((item) => item?.parentFlag);
          setDocList(arrayFilter);
        } else {
          setOpenDialogeMsg(true);
          setDialogMsg('Data not found');
        }
      }
    } catch (error) {
      console.log(error);
    } finally {
      setOpenloader(false);
    }
  };

  // Error Dialog close handler
  const closeDialogMsgHandler = (e) => {
    setOpenDialogeMsg(false);
  };

  useEffect(() => {
    GetDocListApi();
  }, []);

  return (
    <>
      <Loader openloader={openloader} />
      <PageHeading pageTitle="Document list" />
      <Container maxWidth="lg" className="selfRegistrationContainer">
        <Box display="flex" flexDirection="column" justifyContent="center" height="60vh">
          <Typography variant="body1" textAlign="center" className="homeCardHeading" mb={3}>
            {t('Make sure the document includes a picture of your face')}
          </Typography>
          <Box className="documentSelect">
            <Grid container spacing={{ xs: 1, sm: 2, md: 3 }} justifyContent="center">
              {docList.length > 0 &&
                docList.map((item, index) => (
                  <Grid item xs={12} sm={12} md={12} key={`doc-${index}`}>
                    <Stack
                      onClick={() => {
                        if (ocrType === 'false') {
                          const urlParams = `?id=${item.id}&document_code=${item.documentCode}&document_name=${item.documentName}&side_flag=${item.sideFlage}&ocrType=NonOcr`;
                          navigate(`/in/document-photo/${urlParams}`);
                        } else {
                          const urlParams = `?id=${item.id}&document_code=${item.documentCode}&document_name=${item.documentName}&side_flag=${item.sideFlage}&ocrType=ocr`;
                          navigate(`/in/document-photo/${urlParams}`);

                          // set journey ID which is required in the end
                          let existingJourney = localStorage.getItem('journey');
                          existingJourney = existingJourney ? JSON.parse(existingJourney) : {};

                          let newData = {};
                          newData = {
                            ...existingJourney,
                            id: item.id
                          };
                          localStorage.setItem('journey', JSON.stringify(newData));
                          // set journey ID which is required in the end
                        }
                      }}
                    >
                      {/* demo purpose otherwise visible */}
                      <Box
                        className="cardBox"
                        mb={1}
                        display="flex"
                        alignItems="center"
                        style={{ width: '100%' }}
                      >
                        <img
                          src="/static/icons/aadhar_card_icon.svg"
                          alt={item?.documentName}
                          className="documentChooseIcon"
                        />
                        <Typography variant="h5" className="cardHeading">
                          {/* {item?.documentName} */}
                          {t(item?.documentName)}
                        </Typography>
                      </Box>
                      {/* demo purpose otherwise visible */}

                      {/* demo purpose otherwise delete */}
                      {/* {item?.documentCode !== 'ELECTRICITY_BILL' ? (
                        <Box
                          className="cardBox"
                          mb={1}
                          display="flex"
                          alignItems="center"
                          style={{ width: '100%' }}
                        >
                          <img
                            style={{ marginRight: '15px', maxWidth: '40px' }}
                            src="/static/icons/aadhar_card_icon.svg"
                            alt={item?.documentName}
                          />
                          <Typography variant="h6" className="cardHeading">
                            {item?.documentName}
                          </Typography>
                        </Box>
                      ) : (
                        ''
                      )} */}
                      {/* demo purpose otherwise delete */}
                    </Stack>
                  </Grid>
                ))}
            </Grid>
          </Box>
        </Box>
        {/* Dialog msg when if error */}
        <DialogMsg
          openDialogeMsg={openDialogeMsg}
          dialogMsg={dialogMsg}
          dialogTitle="Alert"
          buttonText="Close"
          closeDialogMsgHandler={closeDialogMsgHandler}
        />
      </Container>
    </>
  );
};

export default DocumentChoose;
